import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
interface CTABannerProps {
  title?: string;
  subtitle?: string;
}
export function CTABanner({
  title = 'Ready for a Cleaner Home?',
  subtitle = 'Contact us today for a free, no-obligation quote.'
}: CTABannerProps) {
  return <section className="bg-navy py-16 relative overflow-hidden" data-id="element-39">
      {/* Background Accent */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-light-blue opacity-10 blur-3xl" data-id="element-40"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-steel-blue opacity-10 blur-3xl" data-id="element-41"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-42">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-43">
          <div className="text-center md:text-left" data-id="element-44">
            <h2 className="text-3xl md:text-4xl font-montserrat text-white mb-4" data-id="element-45">
              {title}
            </h2>
            <p className="text-cream text-lg max-w-2xl" data-id="element-46">{subtitle}</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0" data-id="element-47">
            <a href="tel:586-298-2727" className="flex items-center text-white text-xl font-bold hover:text-light-blue transition-colors" data-id="element-48">
              <Phone className="w-6 h-6 mr-2" data-id="element-49" />
              586-298-2727
            </a>
            <Link to="/contact" className="bg-light-blue text-dark font-bold py-3 px-8 rounded-md hover:bg-white transition-colors shadow-lg" data-id="element-50">
              Get Your Free Quote
            </Link>
          </div>
        </div>
      </div>
    </section>;
}